import { useQuery } from "react-query";
import { getPlanSubjects } from "../services/school/PlanSubjects";
import { PagedRequestType } from "../types/PagedResults";
import { getStudentSubjectGrade } from "../services/school/student/createStudent";

export const useGetStudentGradeSubjectsQuery = (data: PagedRequestType, options: any = null) =>
    useQuery(
        ['useGetStudentGradeSubjectsQuery', JSON.stringify(data)],
        () => getStudentSubjectGrade(data),
        options ? { ...options } : {}
    );